<template>
  <div class="register-client">
    <div class="preloader" v-if="!dataLoaded">
      <b-spinner variant="primary" type="grow" label="Spinning"></b-spinner>
    </div>
    <form class="client-form" v-if="dataLoaded" @submit.prevent="saveData()">
      <div class="form__title">
        Отредактировать
        <br />презентацию
      </div>
      <div class="form__title"></div>

      <label class="search-label">
        <input
          type="text"
          name="company"
          autocomplete="off"
          disabled
          class="disabled"
          placeholder="Клиент"
          v-model="presentInfo.client.name"
        />
      </label>
      
      <input
        type="text"
        name="place"
        disabled
        class="disabled"
        autocomplete="off"
        placeholder="Регион"
        v-model="presentInfo.client.region"
      />
      
      <input
        type="text"
        name="phone"
        disabled
        class="disabled"
        autocomplete="off"
        placeholder="Телефон"
        v-model="presentInfo.client.phone"
      />
      
      <input
        type="text"
        name="email"
        disabled
        class="disabled"
        autocomplete="off"
        placeholder="email"
        v-model.trim="presentInfo.client.email"
        
      />

      <input
        type="date"
        name="presentationDate"
        class="presentationDate"
        placeholder="Дата Презентации дд.мм.гггг"
        v-model="date"
        :class="{ error: $v.date.$dirty && !$v.date.required }"
      />

       <label
            class="error"
            v-if="$v.date.$dirty && !$v.date.required"
            >Поле 'Дата Презентации' не должно быть пустым</label
        >
      
      <input
        type="submit"
        value="сохранить"
        id="registerClient"
      />
    </form>
  </div>
</template>
<script>
import {required} from "vuelidate/lib/validators"; //валидатор
export default {
  data: () => ({
      presentInfo: {},
      dataLoaded: false,
      date: '' //Для валидатора
  }),
  validations: {
    date: { required } //Валидация
  },
  methods: {
    startComponent(){
        this.$store.dispatch('GET_PRESENTATION_INFO', this.$route.params.id).then(r => {
            this.presentInfo = r.data.data;
            this.date = this.presentInfo.datePresentation //Валидация
            this.dataLoaded = true
        })
    },
    saveData(){
        if (this.$v.$invalid) {
            this.$v.$touch();
            return;
        } else {
            if(this.presentInfo){
                this.presentInfo.datePresentation = this.date;
                console.log('this.presentInfo', this.presentInfo)
                this.$localStorageSet('editPresentationInfo', this.presentInfo);
                this.$store.dispatch("UPDATE_PRESENTATION", this.presentInfo).then(r => {
                    this.$router.push("/plan/" + this.presentInfo.id);
                })
            }
        }
    }
  },
  created() {
      this.startComponent();
  },
};
</script>
<style lang="scss" scoped>
    .presentationDate::-webkit-inner-spin-button {
        display: none;
    }
    .client-form {
        justify-content: flex-start;
        padding-top: 50px;
    }
    input:not(#registerClient) {
        padding-left: 10px;
    }
    input[type="date"]::-webkit-calendar-picker-indicator {
        background: url("https://cdn3.iconfinder.com/data/icons/linecons-free-vector-icons-pack/32/calendar-16.png")
        center 80% no-repeat;
        color: rgba(0, 0, 0, 0);
        opacity: 1;
    }
    input[type="submit"] {
        position: fixed;
        bottom: 0;
        margin-bottom: 0;
        width: 100%;
        left: 0;
    }
    .search-label {
        margin: 0;
        position: relative;
    }
    .search-result {
        width: 100%;
        background: #fff;
        position: absolute;
        top: 50%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        max-height: 400px;
        overflow-y: auto;
        p {
            padding: 10px;
            font-size: 14px;
        }
    }
    .disabled{
      opacity: 0.5;
    }
</style>